(function () {
  var replacements = [
    ['HiDREAM JAPAN公式ショップへようこそ。愛犬との毎日を、もっと楽しく。', 'HiDREAM JAPAN公式ショップへようこそ。ペットとの毎日を、もっと自由に。'],
    ['Shop', 'ショップ'],
    ['Policy', 'ご利用ガイド'],
    ['Newsletter Signup', 'メールマガジン'],
    ['Copyright © 2026 supershopify all rights reserved.', 'Copyright © 2026 HiDREAM JAPAN All rights reserved.'],
    ['supershopify', 'HiDREAM JAPAN'],
    ['all rights reserved.', 'All rights reserved.']
  ];

  function replaceInTextNode(node) {
    var value = node.nodeValue;
    replacements.forEach(function (pair) {
      value = value.split(pair[0]).join(pair[1]);
    });
    if (value !== node.nodeValue) node.nodeValue = value;
  }

  function replaceText(root) {
    if (!root) return;
    if (root.nodeType === 3) {
      replaceInTextNode(root);
      return;
    }
    if (root.nodeType !== 1) return;

    var tag = root.tagName;
    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parentTag = node.parentNode && node.parentNode.tagName;
        if (parentTag === 'SCRIPT' || parentTag === 'STYLE' || parentTag === 'NOSCRIPT') {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var node;
    while ((node = walker.nextNode())) replaceInTextNode(node);
  }

  function run() {
    replaceText(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(replaceText);
    });
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
